module.exports = function() {
  return new Worker(__webpack_public_path__ + "f913c2525b18ffe827c3.worker.js");
};